import Vue from "vue";
import VueRouter from "vue-router";
import Contents from "@/components/Content";
import Meeting from "@/components/Meeting";
import Files from "@/components/Files";
import MeetTable from "@/components/MeetTable";
import FileTable from "@/components/FileTable";
import FileTableOne from "@/components/FileTableOne";
import UserTable from "@/components/UserTable";
import Word from "@/components/Word";
import Login from "@/views/Login";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Contents",
    component: Contents,
    redirect: '/meeting',
    children: [
      {
        path: "/meeting",
        name: "Meeting",
        component: Meeting,
        redirect: '/meeting/cw',
        children: [
          {
            path: "/meeting/cw",
            name: "CW",
            component: MeetTable,
            meta: {
              title: '常委会会议资料'
            }
          },
          {
            path: "/meeting/db",
            name: "DB",
            component: MeetTable,
            meta: {
              title: '代表大会会议资料'
            }
          },
          {
            path: "/meeting/zr",
            name: "ZR",
            component: MeetTable,
            meta: {
              title: '主任会议资料'
            }
          },
          {
            path: "/meeting/qt",
            name: "QT",
            component: MeetTable,
            meta: {
              title: '其他文件资料'
            }
          },
          {
            path: "/meeting/syyjk",
            name: "SYYJK",
            component: MeetTable,
            meta: {
              title: '审议意见卡'
            }
          },
          {
            path: "/meeting/files/syyjm/:id/:tab",
            name: "SYYJM",
            component: FileTableOne,
            meta: {
              title: '审议意见卡'
            }
          }
        ]
      },
      {
        path: "/files",
        name: "Files",
        component: Files,
        // redirect: "/files/hytz/:id/:tab",
        children: [
          {
            path: "/files/hytz/:id/:tab",
            name: "HYTZ",
            component: FileTable,
            meta: {
              title: '会议通知'
            }
          },
          {
            path: "/files/hywj/:id/:tab",
            name: "HYWJ",
            component: FileTable,
            meta: {
              title: '会议文件'
            }
          },
          {
            path: "/files/syyjm/:id/:tab",
            name: "SYYJM",
            component: FileTableOne,
            meta: {
              title: '审议意见卡'
            }
          },
          {
            path: "/files/csap/:id/:tab",
            name: "CSAP",
            component: FileTable,
            meta: {
              title: '餐宿安排'
            }
          },
          {
            path: "/files/gb/:id/:tab",
            name: "GB",
            component: FileTable,
            meta: {
              title: '公报'
            }
          },
          {
            path: "/files/hyrc/:id/:tab",
            name: "HYRC",
            component: FileTable,
            meta: {
              title: '会议日程'
            }
          },
          {
            path: "/files/zcap/:id/:tab",
            name: "ZCAP",
            component: FileTable,
            meta: {
              title: '座次安排'
            }
          }
        ]
      },
      {
        path: "/user",
        name: "User",
        component: UserTable,
        meta: {
          title: '用户管理'
        }
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: "/dev",
    name: "dev",
    component: Word,
    meta: {
      title: '开发'
    }
  },
];

const router = new VueRouter({
  routes,
});

export default router;
